import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/common-services/common.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-indirect-material',
  templateUrl: './indirect-material.component.html',
  styleUrls: ['./indirect-material.component.scss'],
})
export class IndirectMaterialComponent implements OnInit {
  base_url = environment.BASE_URL;
  products: any;
  categories: any;
  parent_id: number = 15;

  constructor(private commonServices: CommonService) {}
  ngOnInit() {
    this.getCat();
    this.getIndirectMaterial(this.parent_id);
  }

  getIndirectMaterial(parent_id: any) {
    // if (parent_id == 15) {
    // }
    // let apiUrl = `https://develop-shop.unibuild.ai/api/products?category_id=${parent_id}`;
    let apiUrl = `https://develop-shop.unibuild.ai/api/products`;

    this.commonServices.getData(apiUrl).subscribe((data) => {
      this.products = data?.data;
    });
  }
  getCat() {
    let apiUrl = `https://develop-shop.unibuild.ai/api/categories?page=1&limit=100`;

    this.commonServices.getData(apiUrl).subscribe((data) => {
      this.categories = data?.data;
      console.log(this.categories);
    });
  }

  menuItems = [
    {
      name: 'Safety Equipment',
      open: false,
      submenu: [{ name: 'Submenu 1' }, { name: 'Submenu 2' }],
    },
    {
      name: 'CapEx',
      open: false,
      // submenu: [{ name: 'Submenu 1' }, { name: 'Submenu 2' }],
    },
    {
      name: 'Indirect',
      open: false,
      // submenu: [{ name: 'Submenu 1' }, { name: 'Submenu 2' }],
    },
    {
      name: 'Moulding Machine',
      open: false,
      // submenu: [{ name: 'Submenu A' }, { name: 'Submenu B' }],
    },
    {
      name: 'Equipment',
      open: false,
      // submenu: [{ name: 'Submenu A' }, { name: 'Submenu B' }],
    },
    {
      name: 'Air blower',
      open: false,
      // submenu: [{ name: 'Submenu A' }, { name: 'Submenu B' }],
    },
    {
      name: 'Fasteners',
      open: false,
      // submenu: [{ name: 'Submenu A' }, { name: 'Submenu B' }],
    },
    {
      name: 'Safety Equipment',
      open: false,
      // submenu: [{ name: 'Submenu A' }, { name: 'Submenu B' }],
    },
    {
      name: 'Bearings',
      open: false,
      // submenu: [{ name: 'Submenu A' }, { name: 'Submenu B' }],
    },
  ];

  toggleSubmenu(menuItem: { open: boolean }) {
    menuItem.open = !menuItem.open;
  }
}
